/*
  Sterntaler – Suchvorschläge im Header-Lupen-Modal.
  Wirkt auf jedes [data-st-ms-root] (Header-Modal). Das Home-Such-Panel
  ([data-st-ms-wrap]) hat eine eigene, davon unabhängige Logik – hier nicht angefasst.
  "Letzte Suchen" teilen sich denselben Speicher (st_ms_recent) über alle Flächen.
*/
(function () {
  if (window.__stSearchSuggestInit) return;
  window.__stSearchSuggestInit = true;

  var RECENT_KEY = 'st_ms_recent';
  var RECENT_MAX = 6;

  function readRecent() {
    try {
      var raw = window.localStorage.getItem(RECENT_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function storeRecent(term) {
    term = (term || '').trim();
    if (!term) return;
    try {
      var arr = readRecent().filter(function (t) {
        return t.toLowerCase() !== term.toLowerCase();
      });
      arr.unshift(term);
      window.localStorage.setItem(RECENT_KEY, JSON.stringify(arr.slice(0, RECENT_MAX)));
    } catch (e) {}
  }

  function init(root) {
    if (root.dataset.stRootBound === 'true') return;
    root.dataset.stRootBound = 'true';

    var input = root.querySelector('input[type="search"]');
    var panel = root.querySelector('[data-st-ms-quick]');
    if (!input || !panel) return;

    var form = input.form;
    var recentBox = root.querySelector('[data-st-ms-recent]');
    var recentList = root.querySelector('[data-st-ms-recent-list]');
    var recentClear = root.querySelector('[data-st-ms-recent-clear]');
    var searchUrl = root.getAttribute('data-search-url') || '/search';
    var focused = false;
    var closeTimer;

    function renderRecent() {
      if (!recentBox || !recentList) return;
      var arr = readRecent();
      recentList.textContent = '';
      if (!arr.length) {
        recentBox.hidden = true;
        return;
      }
      arr.forEach(function (term) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'st-mobile-search__chip';
        a.href = searchUrl + '?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last';
        a.textContent = term;
        li.appendChild(a);
        recentList.appendChild(li);
      });
      recentBox.hidden = false;
    }

    function refresh() {
      var hasQuery = input.value.trim().length > 0;
      panel.hidden = !(focused && !hasQuery);
    }

    input.addEventListener('focus', function () {
      focused = true;
      renderRecent();
      refresh();
    });
    input.addEventListener('input', refresh);

    root.addEventListener('focusout', function () {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        if (!root.contains(document.activeElement)) {
          focused = false;
          refresh();
        }
      }, 150);
    });

    panel.addEventListener('mousedown', function (e) {
      if (e.target.closest('[data-st-ms-recent-clear]')) return;
      e.preventDefault();
    });

    if (recentClear) {
      recentClear.addEventListener('click', function (e) {
        e.preventDefault();
        try { window.localStorage.removeItem(RECENT_KEY); } catch (err) {}
        renderRecent();
        input.focus();
      });
    }

    if (form) {
      form.addEventListener('submit', function () {
        storeRecent(input.value);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-st-ms-root]').forEach(init);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }
  document.addEventListener('shopify:section:load', initAll);
})();